export default __webpack_public_path__ + "static/media/logo-umid-color.6abe6533.png";